import { RouteInfo } from './vertical-menu.metadata';

//Sidebar menu Routes and data
export const ROUTES_ADMIN: RouteInfo[] = [
    {
        path: '/workspace/main', title: 'Workspace', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
    {
        path: '',
        title: 'Onboard Clientes',
        icon: 'ft-align-left',
        class: 'has-sub',
        badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
        badge: '',
        isExternalLink: false,
        submenu: [
            {
                path: '/task/listmine',
                title: 'Minhas Tarefas',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/task/listall',
                title: 'Processos',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            }
        ]
    },
    {
        path: '',
        title: 'Clientes',
        icon: 'ft-align-left',
        class: 'has-sub',
        badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
        badge: '',
        isExternalLink: false,
        submenu: [
            {
                path: '/company/listCustomer',
                title: 'Cadastros',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/invoice/list',
                title: 'Notas Emitidas',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/takenInvoice/list',
                title: 'Notas tomadas',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/tax/list',
                title: 'Impostos',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/recurringinvoice/list',
                title: 'Notas Recorrentes',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/das/list',
                title: 'Extrato DAS',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/company/meideclaration',
                title: 'Declaração anual MEI',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/externalbilling/list',
                title: 'Faturamento Externo',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/inssabsence/list',
                title: 'Afastamento INSS',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/company/listCertificades',
                title: 'Certificados',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            }
        ]
    },
    {
        path: '/company/listPartner',
        title: 'Parceiros',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/company/calendar',
        title: 'Calendário',
        icon: 'ft-calendar',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/ofx/list',
        title: 'Extrato',
        icon: 'ft-check-circle',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '',
        title: 'Meus Painéis',
        icon: 'ft-align-left',
        class: 'has-sub',
        badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
        badge: '',
        isExternalLink: false,
        submenu: [
            {
                path: '/dashboard/dashboard1',
                title: 'Qtd x Tarefas',
                icon: 'ft-user',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/dashboard/dashboard2',
                title: 'Qtd x Responsáveis',
                icon: 'ft-user',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/dashboard/invoicing',
                title: 'Faturamento',
                icon: 'ft-user',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
        ]
    },
    {
        path: '',
        title: 'Administração',
        icon: 'ft-align-left',
        class: 'has-sub',
        badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
        badge: '',
        isExternalLink: false,
        submenu: [
            {
                path: '/userb/list',
                title: 'Usuários',
                icon: 'ft-user',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/userbgroup/list',
                title: 'Grupos de Usuários',
                icon: 'ft-users',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            }
        ]
    },
    {
        path: '',
        title: 'Solicitações',
        icon: 'ft-bell',
        class: 'has-sub',
        badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
        badge: '',
        isExternalLink: false,
        submenu: [
            {
                path: '/request/list',
                title: 'Minhas solicitações',
                icon: 'ft-align-left',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/request/list/all',
                title: 'Todas',
                icon: 'ft-align-left',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            }
        ]
    },
];

export const ROUTES_OPER: RouteInfo[] = [
    {
        path: '/workspace/main',
        title: 'Workspace',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '',
        title: 'Onboard Clientes',
        icon: 'ft-align-left',
        class: 'has-sub',
        badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
        badge: '',
        isExternalLink: false,
        submenu: [
            {
                path: '/task/listmine',
                title: 'Minhas Tarefas',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/task/listall',
                title: 'Processos',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            }
        ]
    },
    {
        path: '',
        title: 'Clientes',
        icon: 'ft-align-left',
        class: 'has-sub',
        badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
        badge: '',
        isExternalLink: false,
        submenu: [
            {
                path: '/company/listCustomer',
                title: 'Cadastros',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/invoice/list',
                title: 'Notas Emitidas',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/takenInvoice/list',
                title: 'Notas tomadas',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/recurringinvoice/list',
                title: 'Notas Recorrentes',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/externalbilling/list',
                title: 'Faturamento Externo',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/inssabsence/list',
                title: 'Afastamento INSS',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            },
            {
                path: '/company/listCertificades',
                title: 'Certificados',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            }
        ]
    },
    {
        path: '/company/listPartner',
        title: 'Parceiros',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
];

export const ROUTES_CUSTOMER: RouteInfo[] = [
    {
        path: '/workspace/simples_lp',
        title: 'Workspace',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/company/view',
        title: 'Meu Cadastro',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/invoice/issueList',
        title: 'Emitir Notas',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/invoice/list',
        title: 'Notas Emitidas',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/takenInvoice/list',
        title: 'Notas tomadas',
        icon: 'ft-check-circle',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/ofx/list',
        title: 'Extrato',
        icon: 'ft-check-circle',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/tax/list',
        title: 'Impostos',
        icon: 'ft-check-circle',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/company/documents',
        title: 'Meus Documentos',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/externalbilling/list',
        title: 'Faturamento Externo',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/inssabsence/list',
        title: 'Afastamento INSS',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/request/list',
        title: 'Minhas Solicitações',
        icon: 'ft-file-text',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
];

export let ROUTES_CUSTOMER_MEI: RouteInfo[] = [
    {
        path: '/workspace/mei',
        title: 'Workspace',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/company/view',
        title: 'Meu Cadastro',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/invoice/issueList',
        title: 'Emitir Notas',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/invoice/list',
        title: 'Notas Emitidas',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/takenInvoice/list',
        title: 'Notas tomadas',
        icon: 'ft-check-circle',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/das/list',
        title: 'Extrato DAS',
        icon: 'ft-check-circle',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/ofx/list',
        title: 'Extrato',
        icon: 'ft-check-circle',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/company/meideclaration',
        title: 'Declaração anual MEI',
        icon: 'ft-check-circle',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/company/documents',
        title: 'Meus Documentos',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/externalbilling/list',
        title: 'Faturamento Externo',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/inssabsence/list',
        title: 'Afastamento INSS',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/request/list',
        title: 'Minhas Solicitações',
        icon: 'ft-file-text',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
];

export const ROUTES_PARTNER: RouteInfo[] = [
    {
        path: '/workspace/partner',
        title: 'Workspace',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/company/partnervinculated',
        title: 'Cadastros',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/recurringinvoice/listInvoiceNew',
        title: 'Notas Recorrentes',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/takenInvoice/list',
        title: 'Notas tomadas',
        icon: 'ft-check-circle',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/invoice/list',
        title: 'Notas Recebidas',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/das/list',
        title: 'Extrato DAS',
        icon: 'ft-check-circle',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/company/documents',
        title: 'Meus Documentos',
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
];

export const ROUTES_CUSTOMER_PROCESS_OPEN: RouteInfo[] = [
    {
        path: '/workspace/onboard', title: 'Onboarding', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
      {
         path: '/tax/list',
                title: 'Impostos',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
    }
];
export const ROUTES_CUSTOMER_MIGRATION: RouteInfo[] = [
    {
        path: '/company/accounting-migration', title: 'Onboarding', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
    {
       path: '/tax/list',
                title: 'Impostos',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
    },
];
export const ROUTES_NOT_READY: RouteInfo[] = [
    {
        path: '/company/open-company', title: 'Onboarding', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
      {
         path: '/tax/list',
                title: 'Impostos',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
    }
];
export const ROUTES_CONTACT_CONTAZZ: RouteInfo[] = [
    {
        path: '/company/contact-contazz-company', title: 'Onboarding', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
      {
         path: '/tax/list',
                title: 'Impostos',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
    }
];
export const ROUTES_OPEN_COMPANY: RouteInfo[] = [
    {
        path: '/company/open-company', title: 'Onboarding', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
      {
         path: '/tax/list',
                title: 'Impostos',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
    }
];
export const ROUTES_CUSTOMER_MIGRATION_WELCOME: RouteInfo[] = [
    {
        path: '/company/welcome-migration', title: 'Onboarding', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
    {
         path: '/tax/list',
                title: 'Impostos',
                icon: 'ft-check-circle',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
    }
];

